import React, { lazy } from 'react';

import { AuthRoute } from '../auth/components';

const ConveyancingFlow = lazy(() => import('./pages/ConveyancingFlow'));

const conveyancingJourneyFlowModule = {
  routes: [
    <AuthRoute
      key="conveyancing"
      exact
      path="/conveyancing/:journeyId/:step"
      component={ConveyancingFlow}
      headerType="private"
    />
  ],
};

export default conveyancingJourneyFlowModule;
